import reducer from './reducers';

export { default as bookingCollectionSelectors } from './selectors';
export { default as bookingCollectionOperations } from './operations';
export { default as bookingCollectionTypes } from './types';

export default reducer;
